/**
 * @file
 */

import { CreateTHEADSectionGV } from "@/common/common.js";

export function InitializeOLPPaymentSchedulingReviewPage() {
   // -------------------------------------------------------------------------------------------
   // create the thead section for the gridview since datagrids don't natively have it.
   //    this is mainly for ADA
   // -------------------------------------------------------------------------------------------
   CreateTHEADSectionGV("gvLoanDetails");

   // -------------------------------------------------------------------------------------------
   // initialize gridview to handle responsive web design
   // -------------------------------------------------------------------------------------------
   $('.responsiveTable').DataTable({
      "responsive": {
         "details": {
            display: $.fn.dataTable.Responsive.display.childRowImmediate,
            type: ''
         }
      },
      "scrollX": false,
      "paging": false,
      "searching": false,
      "ordering": false,
      "info": false
   });
};
